[<template>
  <div>
    <el-table
      :data="blogs.data"
      :default-sort="{ prop: order_column, order: order_type }"
      @sort-change="sort"
      class="w100"
      stripe
    >
      <el-table-column label="Author" prop="name" sortable></el-table-column>
      <el-table-column label="Title" prop="title" sortable></el-table-column>
      <el-table-column label="Create date" prop="created_at" sortable>
        <template slot-scope="props">
          {{ props.row.created_at | date }}
        </template>
      </el-table-column>
      <el-table-column label="Publish date" prop="publish_time" sortable>
        <template slot-scope="props">
          {{ props.row.publish_time | date }}
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right" width="200%">
          <template slot-scope="props">
            <el-tooltip content="Publish" placement="top" v-if="props.row.publish_time == null">
              <el-button
                type="success"
                circle
                size="small"
                icon="el-icon-top"
                @click="publishBlog(props.row.id)"
              ></el-button>
            </el-tooltip>
            <el-tooltip content="Unpublish" placement="top" v-if="props.row.publish_time !== null">
              <el-button
                type="danger"
                circle
                size="small"
                icon="el-icon-bottom"
                @click="unpublishBlog(props.row.id)"
              ></el-button>
            </el-tooltip>
            <el-tooltip content="Edit" placement="top">
              <el-button
                type="warning"
                circle
                size="small"
                icon="el-icon-edit"
                @click="openEdit(props.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip content="Delete" placement="top">
              <el-button
                type="danger"
                circle
                size="small"
                icon="el-icon-close"
                @click="deleteB(props.row.id)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="blogs.current_page"
      :page-sizes="[5, 10, 25, 50, 100]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="blogs.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('blog', [
      'blogs',
      'page',
      'page_size',
      'order_column',
      'order_type'
    ])
  },

  methods: {
    ...mapActions('blog', [
      'read',
      'delete',
      'publish',
      'unpublish'
    ]),
    ...mapMutations('blog', [
      'setPage',
      'setPageSize',
      'setOrdering',
      'setDialog',
      'setSelectedBlog'
    ]),

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.read()
    },
    currentChange(page) {
      this.setPage(page)
      this.read()
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.read()
    },
    openEdit(blog) {
      this.setDialog(true)
      this.setSelectedBlog(blog)
    },
    deleteB(id) {
      this.$confirm(
        'You will permanently delete this blog. Continue?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          this.delete(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete cancelled'
          })
        })
    },
    publishBlog(id) {
      this.$confirm(
        'You will publish this blog. Continue?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          this.publish(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Publish cancelled'
          })
        })
    },
    unpublishBlog(id) {
      this.$confirm(
        'You will unpublish this blog. Continue?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          this.unpublish(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Unpublish cancelled'
          })
        })
    }

  },

  created() {
    this.read()
  }
}
</script>
]
